import BillingPricingComponent from "./component"

class BillingPricingInterval extends BillingPricingComponent {
  static get selector() {
    return "[data-billing-pricing-interval]"
  }

  init() {
    this.value = this.element.dataset.billingPricingInterval
    this.selected = this.element.dataset.billingPricingIntervalPreselected === "true"

    this.element.addEventListener("click", (e) => {
      this.pricing.setInterval(this)
    })

    this.initialized()
  }

  valid() {
    return super.valid() && this.value
  }

  select() {
    if (this.selected) {
      return
    }

    this.selected = true
    this.element.classList.remove("text-gray-600")
    this.element.classList.add("bg-blue-600", "text-white")
  }

  unselect() {
    this.selected = false
    this.element.classList.remove("bg-blue-600", "text-white")
    this.element.classList.add("text-gray-600")
  }
}

export default BillingPricingInterval
